import React from 'react'
import { config } from '../../config';
import httpservice from '../../_service/httpservice';
import { Link } from "react-router-dom";
const SearchFilter = (props: any) => {
    const [filterData, setFilterData] = React.useState<any>([]);
    const [selectedParent, setSelectedParent] = React.useState<any>('');
    const getFilterData = async () => {
        var win = (window as any);
        const url = `${win.depUrl}/${win.currentDep}`;
        const headers = { 'page': 0, 'limit': 2000 }
        const res = await httpservice.action.get(url, null, headers);
        setFilterData(res?.data);
        (window as any).callBackOnRenderDep();
    }
    React.useEffect(() => {
        getFilterData()
    }, [])
    React.useEffect(() => {
        if (props.parent) {
            setSelectedParent(props.parent)
        }
       
    }, [props.parent])
    const handleFilter = (item: any, depIds: string[]) => {
        setSelectedParent(item.name)
        const departmentID = item?.departmentID;
        props?.handleFilter(departmentID)
    }
    const toggleNav = (item: any) => {
        if (selectedParent == item.name) {
            setSelectedParent('')
        } else {
            setSelectedParent(item.name)
        }
    }
    const renderDep = (dep: any, depSeries: string[], isMain: boolean = false) => {
        var isChild = dep.childrens && dep.childrens.length > 0;
        let deps = [...depSeries, dep.departmentID];
        if (isChild) {
            return (
                <li className="dropdown-head position-relative abd" key={`level2_${dep.departmentID}`} id={`level2_${dep.departmentID}`}>
                    
                    {/*<div className={`position-absolute plus-sign ${isMain ? "plus" : "plus-sub"}`}></div>*/}
                    <input className="expendCollps" type="checkbox" />
                    <a href="#" className="dropdown-btn dropdown-btn-menu">{dep?.name}</a>
                    <ul key={`level_${dep?.departmentID}`} className={isMain ? "dp-l1" : "sub-dropdown"}>
                        {dep.childrens.map((level1: any, level1Index: number) => renderDep(level1, deps))}
                    </ul>
                </li>
            )
        }
        else {
            return (<li key={`level2_${dep.departmentID}`} className="position-relative">
                <label key={`lvl_${dep.departmentID}`} >
                    {dep?.name}
                    <input key={`chk_${dep.departmentID}`} onClick={() => handleFilter(dep, deps)} className="position-absolute check-box" type="checkbox" />
                </label>
            </li>)
        }
    }
    return (
        <>
            <nav className="navbar">
                <h3 className="heading-h3">Filter by</h3>
                <p className="sub-heading"><a href={props?.currentDep?.searchUrl}>All</a></p>
                <ul id="tree1" className="dropdown p-0">
                    {filterData && filterData.childrens && filterData.childrens.length > 0 && filterData.childrens.map((level1: any, level1Index: number) => {
                        let data: string[] = [];
                        data.push(level1.departmentID);
                        return renderDep(level1, data, true)
                    })}

                </ul>
            </nav>
        </>
    )
}
export default SearchFilter;
